import React from 'react';
import { motion } from 'framer-motion';
import { OfferSelector } from './OfferSelector';
export function Footer() {
  return <footer className="bg-brand-dark pt-10 pb-6 md:pt-20 md:pb-10 border-t border-brand-border relative overflow-hidden" data-id="element-85">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-red/5 rounded-t-full blur-3xl -z-10 pointer-events-none" data-id="element-86"></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center" data-id="element-87">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-6xl font-serif font-bold text-white mb-4 md:mb-6" data-id="element-88">
          Un fin de semana.{' '}
          <span className="text-brand-gold italic" data-id="element-89">Para siempre.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-base md:text-xl text-gray-400 mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-90">
          Cocinás bien, ahorrás plata y la próxima vez que venga la suegra, vos
          sos el que cocina.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="max-w-2xl mx-auto text-left mb-10 md:mb-16" data-id="element-91">
          <OfferSelector data-id="element-92" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="border-t border-brand-border/50 pt-8 md:pt-10 flex flex-col items-center gap-3 md:gap-4" data-id="element-93">
          <p className="text-white font-serif font-bold text-base md:text-lg flex items-center gap-2" data-id="element-94">
            🍳 OPERACIÓN SUEGRA™{' '}
            <span className="text-brand-gold text-xs md:text-sm font-sans font-normal" data-id="element-95">
              · Chef de Barrio
            </span>
          </p>
          <p className="text-gray-500 text-xs md:text-sm" data-id="element-96">
            El sistema de cocina N°1 para principiantes en Argentina.
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-400 mt-2 md:mt-4" data-id="element-97">
            <a href="mailto:soportenichodigital@gmail.com" className="hover:text-brand-gold transition-colors" data-id="element-98">
              soportenichodigital@gmail.com
            </a>
            <span className="hidden sm:inline" data-id="element-99">·</span>
            <span className="hover:text-brand-gold transition-colors cursor-pointer" data-id="element-100">
              @nichodigital
            </span>
            <span className="hidden sm:inline" data-id="element-101">·</span>
            <span className="hover:text-brand-gold transition-colors cursor-pointer" data-id="element-102">
              nichodigital.shop
            </span>
          </div>

          <p className="text-gray-600 text-[10px] md:text-xs mt-6 md:mt-8" data-id="element-103">
            © NichoDigital.shop™ 2026 — Todos los derechos reservados.
          </p>
        </motion.div>
      </div>
    </footer>;
}